module.exports = __webpack_public_path__ + "static/media/kz.d37cbd61.svg";